import { BRANCH_NAME } from "../config";

export const DATE_FORMAT_FOR_DISPLAY = "DD/MM/YYYY";
export const DATETIME_FORMAT_FOR_DISPLAY = "DD/MM/YYYY HH:mm";
export const DATE_FORMAT_FOR_API = "YYYY-MM-DD";
export const DATETIME_FORMAT_FOR_API = "YYYY-MM-DD HH:mm";
export const CURRENCY_FORMAT_FOR_DISPLAY = "0,0.00 $";
export const DATETIME_FORMATZ_FOR_API = "YYYY-MM-DDTHH:mm:ss.SSS[Z]";

const ALLOWED_COMIC_TEST_STUDIO = {
  /* "00003123122": ["david.rodigari+demo-studio@mondora.com"],
  "00000250043": ["francobrandani2020@gmail.com"],
  "11145452584": ["ambitotest+studiobenedetti@gmail.com"],*/
  "00000012179": ["marcoviti2021@gmail.com"]/* ,
  "01845664893": ["agyotest2019+201@gmail.com", "agyotest2019+204@gmail.com"],
  "02584884890": ["agyotest2019+202@gmail.com"],
  "ZLLLSS89L19L500C": ["a.zellini@teamsystem.com"],
  "PRDLSS83P62C632Z": ["a.pierdomenico@teamsystem.com"],
  "07848500067": ["s.biressi@teamsystem.com"],
  "VSLLDA83R24E456U": ["a.iavasile@teamsystem.com"],
  "CRRNNA80R44G273Y": ["a.curreri@teamsystem.com"]*/
};
const ALLOWED_COMIC_DEV_STUDIO = {"00000010215" : ["mikpalazzo90@gmail.com"]};
const ALLOWED_COMIC_MASTER_STUDIO = {
  /* "03680680968": ["david.rodigari+m-studio@mondora.com"],
  "02897530347": ["simone.maugeri@banzi.partners"],
  "RVRGNN74H19C933N": ["gioravera@libero.it"],
  "DJLMSM62C01H501U": ["massimilianodajello@gmail.com"],
  "02874210350": ["e.aiza@gmdbenefit.com", "g.pahor@gmdbenefit.com", "f.toso@gmdbenefit.com", "s.dovier@gmdbenefit.com"]*/
};

export const ALLOWED_COMIC_STUDIO = BRANCH_NAME === "master" ? ALLOWED_COMIC_MASTER_STUDIO : BRANCH_NAME === "dev" ? ALLOWED_COMIC_DEV_STUDIO : ALLOWED_COMIC_TEST_STUDIO;